import { Box, styled, Typography, Button } from '@mui/material';

export const PurchaseCardContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 24px;
	align-items: start;

	width: 100%;
	min-width: 360px;
	max-width: calc((100vw / 2) - 45px);

	height: 100%;
	min-height: 555px;
	max-height: 555px;

	background-color: #262626;
	border-radius: 16px;
	padding: 48px 48px 48px 48px;

	font-family: 'Manrope', sans-serif;

	@media (max-width: 768px) {
		padding: 0 32px 24px 32px;
	}
`;

export const TagTopGradient = styled(Box)`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	padding: 8px 0;

	border-radius: 0 0 8px 8px;

	width: 100%;
	background: linear-gradient(68deg, rgba(71, 228, 166, 0.1) 0.58%, rgba(76, 206, 221, 0.1) 99.42%), #262626;

	color: #cccccc;
`;

export const TagTop = styled(Box)`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	padding: 8px 4px;

	border-radius: 0 0 8px 8px;

	border: 1px solid #999;
	border-top: none;

	width: 100%;
	background: #4c4c4c;

	color: #cccccc;
`;

export const BorderGradientWrapper = styled(Box)`
	width: 100%;
	height: 100%;

	padding: 0 1px 1px 1px;
	border-radius: 0 0 8px 8px;

	background: linear-gradient(#47e4a6 0%, #4ccedd 100%);
`;

export const BorderWrapper = styled(Box)`
	width: 100%;
	height: 100%;

	padding: 0 1px 1px 1px;
	border-radius: 0 0 8px 8px;

	background: #99999;
`;

export const MainTitle = styled(Typography)`
	font-family: 'Manrope', sans-serif;
	color: #fcfcfc;
	font-weight: bold;
	font-size: 48px;

	padding: 10px 0;

	@media (max-width: 768px) {
		font-size: 32px;
	}
`;

export const MainTitleV2 = styled(Typography)`
	font-family: 'Manrope', sans-serif;
	color: #fcfcfc;
	font-weight: bold;
	font-size: 40px;

	padding: 10px 0;

	@media (max-width: 768px) {
		font-size: 24px;
	}
`;

export const TextGradient = styled(Typography)`
	font-family: 'Manrope', sans-serif;

	background-color: var(--color-revalida-2);
	background-image: var(--gradient-revalida2025);

	line-height: 32px;
`;

export const Title = styled(Typography)`
	font-family: 'Manrope', sans-serif;
	font-size: 16px;
	line-height: 16px;

	padding-top: 8px;
`;

export const Description = styled(Typography)`
	font-family: 'Manrope', sans-serif;
	font-size: 16px;
	line-height: 20px;

	padding-top: 8px;

	white-space: pre-wrap;
`;

export const ButtonDefault = styled(Button)`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;

	font-family: 'Manrope', sans-serif;
	font-size: 16px;
	color: white;

	width: 100% !important;
	height: 40px;
	border-radius: 80px;
	padding: 0 40px;

	text-transform: unset;
`;

export const TagDiscount = styled('span')`
	color: #f1f1f1;

	width: fit-content;
	font-family: 'Outfit', sans-serif;
	font-size: 12px;
	border-radius: 4px;
	padding: 6px;

	background-color: #00ad5880;
`;

export const ExtraContent = styled(Box)`
	width: 100%;
	background-color: #191919;
	border: 1px solid #303030;
	border-radius: 8px;
	padding: 16px;

	cursor: pointer;
`;

export const CollapseContent = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 4px;
`;
